import { useMemo } from 'react';

import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';
import { invocationStepExecutionPath } from '@/utils/monolithApiRouteService';

type StepExecution = {
  stepTitle: string;
};

const useInvocationStepExecution = (
  workspaceSlug: string,
  buildTool: string,
  invocationId: string,
  stepExecutionId: string | undefined,
  enabled = true,
) => {
  const url = useMemo(() => {
    return invocationStepExecutionPath(workspaceSlug, buildTool, invocationId, stepExecutionId ?? '');
  }, [workspaceSlug, buildTool, invocationId, stepExecutionId]);

  const { data, isError, error, isFetching, isLoading, refetch } = useMonolithApiQuery<
    StepExecution,
    SimpleErrorResponse
  >(['buildToolInvocationStepExecution', url], url, { enabled });

  return {
    stepTitle: data?.stepTitle,
    error: isError && error?.response ? new Error(error.response?.data.errorMsg) : null,
    refetch,
    isFetching,
    isLoading,
  };
};

export default useInvocationStepExecution;
